// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__26zPP","disabledButton":"Button_disabledButton__3EJ7K Button_Button__26zPP","buttonText":"Button_buttonText__3kMGx"};